import { TableCell } from '@mui/material'

const UnitPriceCellCollapsible = () => <TableCell colSpan={2} />

export default UnitPriceCellCollapsible
